import type { Locale } from "./locales";

export type Catalog = Record<string, string>;

/**
 * Dynamic-import the catalog for a locale. Each catalog ships in its own
 * chunk so we don't bundle 7 languages into the main JS payload.
 *
 * `en` is the always-loaded fallback for missing keys (see I18nContext).
 */
export async function loadCatalog(locale: Locale): Promise<Catalog> {
  switch (locale) {
    case "en":
      return (await import("../../../messages/en.json")).default as Catalog;
    case "en-GB":
      return (await import("../../../messages/en-GB.json")).default as Catalog;
    case "es":
      return (await import("../../../messages/es.json")).default as Catalog;
    case "fr":
      return (await import("../../../messages/fr.json")).default as Catalog;
    case "it":
      return (await import("../../../messages/it.json")).default as Catalog;
    case "de":
      return (await import("../../../messages/de.json")).default as Catalog;
    case "pt-BR":
      return (await import("../../../messages/pt-BR.json")).default as Catalog;
  }
}
